import { DefaultPortModel, PortModelAlignment } from '@projectstorm/react-diagrams';

import { PipeLinkModel } from '../links/PipeLink';

export class FourPortPipeModel extends DefaultPortModel {
  constructor(private alignment: PortModelAlignment) {
    super({
      type: 'pipe',
      name: alignment,
      alignment: alignment,
    });
    this.alignment = alignment;
  }

  createLinkModel(): PipeLinkModel {
    return new PipeLinkModel(null);
  }

  canLinkToPort() {
    return true;
  }
}
